// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"26":"7416c55d","310":"e0ad3aa7","406":"f0342d1c","920":"219f8eee"}[chunkId] + ".css";
};